import type { EmailTemplate } from "@redotech/redo-model/email-template";
import { emailTemplateSchema } from "@redotech/redo-model/email-template";
import type { SavedEmailTemplate } from "@redotech/redo-model/saved-email-template";
import { savedEmailTemplateSchema } from "@redotech/redo-model/saved-email-template";

import { z } from "zod";

export const createSavedEmailTemplate = {
  input: z.object({
    template: emailTemplateSchema as z.ZodType<EmailTemplate>,
    name: z.string(),
    tags: z.array(z.string()).optional(),
  }),
  output: savedEmailTemplateSchema as z.ZodType<SavedEmailTemplate>,
};
